import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { UpgradePackRequest } from './upgradepackrequest';

export class UpgradePackAPI extends SixdeeCRBTAPI<UpgradePackRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        return "pack-upgrade";
    }

    getRequestData()
    {
            return "clientTxnId=1710219006"+"&"+
            "aPartyMsisdn="+ this.getRequest().getUpgradePackRequest().getMsisdn()+"&"+
            "serviceId=9&"+
            "toneId="+ this.getRequest().getUpgradePackRequest().getToneId()+"&"+
            "packName="+ this.getRequest().getUpgradePackRequest().getPackName()+"&"+
            "priority=0&"+
            "&"+"channelId="+ this.getRequest().getUpgradePackRequest().getChannel();
       
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/upgradepack/upgradepackapi.tsx